import React from 'react';
import './chevron-desktop-top-part.scss';
import { ChevronProps } from '../../../shared/props-types/chevron.props';

const ChevronDesktopTopPart = ({ chevron }: ChevronProps) => {
  const { color } = chevron;

  return (
    <div
      className="chevron-desktop-top-part"
      style={{ backgroundColor: color }}
    ></div>
  );
};

export default ChevronDesktopTopPart;
